import { Check, Copy } from "lucide-react"
import { useState } from "react"

// IMP-521: the small copy-to-clipboard affordance next to an identifier.
// Flips to a check for a beat so the copy is visibly acknowledged.
export function CopyButton({ value, label }: { value: string; label: string }) {
  const [done, setDone] = useState(false)
  return (
    <button
      type="button"
      aria-label={label}
      onClick={() => {
        void navigator.clipboard?.writeText(value)
        setDone(true)
        setTimeout(() => setDone(false), 1500)
      }}
      className="text-muted-foreground hover:text-foreground hover:bg-muted grid size-6 place-items-center rounded-md transition-colors"
    >
      {done ? <Check className="size-3.5" /> : <Copy className="size-3.5" />}
    </button>
  )
}
